import { MutationCache, QueryClient } from '@tanstack/react-query'
import { del, get, set } from 'idb-keyval'
import { registerDefaultMutations } from './mutations'
import type {
  PersistedClient,
  Persister,
} from '@tanstack/react-query-persist-client'

export const DEFAULT_RETRY_MUTATION = 2

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: DEFAULT_RETRY_MUTATION,
      staleTime: 1000 * 60 * 5,
      gcTime: 1000 * 60 * 60 * 24,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
    },
  },
  mutationCache: new MutationCache(),
})

registerDefaultMutations(queryClient)

function createIDBPersister(idbValidKey: IDBValidKey = 'rq_cache') {
  return {
    persistClient: async (client: PersistedClient) => {
      await set(idbValidKey, client)
    },
    restoreClient: async () => {
      const res = await get<string>(idbValidKey)
      if (!res) return undefined
      return res
    },
    removeClient: async () => {
      await del(idbValidKey)
    },
  } as Persister
}

export const queryClientPersister = createIDBPersister()
